#import "../fragments/wf-form-fragment.graphql"

mutation WfFormCreateRulesUpdate($input: FormCreateRulesUpdateInput!) {
    formCreateRulesUpdate(input: $input) {
        form {
            ...WfFormFragment
        }
    }
}
